<template>
    <v-footer app dark class="blue-grey">

        <v-row
            justify="center"
            align="center"
            >
            <slot><span ></span></slot>
        </v-row>
    </v-footer>
</template>
<script>
    export default {
        props: {},
        data() {
            return {}
        },
        mounted() {
        },
        computed: {},
        methods: {},

        components: {},
        filters: {}
    }
</script>
